module.exports = {
      id: "vikatan-play-logo-red-usage",
      viewBox: "0 0 536.066 789.439",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#vikatan-play-logo-red",
      toString: function () {
        return this.url;
      }
    }